import { render, staticRenderFns } from "./AppLegalInfoLink.vue?vue&type=template&id=446a25c8&"
import script from "./AppLegalInfoLink.vue?vue&type=script&lang=js&"
export * from "./AppLegalInfoLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports